import Swal from "sweetalert2";

export const swalCustomButtons = Swal.mixin({
    customClass: {
      confirmButton: 'btn custom-btn',
      cancelButton: 'btn custom-cancel-btn me-3'
    },
    buttonsStyling: false
  });

export const getReturnPage = (result, history, to="/") =>{
    if(result?.isConfirmed) history.push(to)
}
          /**
   * Descarga en formato png la imágen seleccionada
   * @param {string} blobUrl -Url de la imágen codificada
   * @param {string} event - nombre del archivo
   * @author Kenzo Sashida 
   * @version 1.0.0 - Julio 2024
   */
export const downloadBlobImage = (blobUrl, fileName, redirect=false) =>{
    const img = new Image();
    img.crossOrigin = 'Anonymous'; // Permite descargar imágenes de otros dominios
    
    img.onload = function() {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;

        const ctx = canvas.getContext('2d'); //Obtener contexto de un canvas que renderiza en dos dimensiones
        ctx.drawImage(img, 0, 0);

        // Convertir el canvas a un Blob
        canvas.toBlob((blob) => {
            // Crear un enlace para descargar
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            a.click();

            // Limpiar
            URL.revokeObjectURL(url);
        }, 'image/png'); // Tipo de imagen deseado (aquí puedes cambiar a jpeg, por ejemplo)
        img.src = blobUrl;
        if(redirect){
            const newWindow = window.open();
            newWindow.document.write(`<img src="${blobUrl}" alt="Image" />`);
        }
    }
}
export const handleCancel = (response, history, to= "/") =>{
    let responseTitle = '';
    if(response === 'return'){
      responseTitle = 'Regresar';
    } else if(response === 'cancel'){
      responseTitle = 'Cancelar';
    }
    swalCustomButtons.fire({
      title: responseTitle,
      text: "Esta acción eliminará toda información no guardada.",
      icon: 'warning',
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      reverseButtons: true
    }).then((result) => {
        getReturnPage(result, to, history);
    })
}